//@flow
import React, {useEffect, useState} from 'react';
import {
  Typography,
  FormControlLabel,
  Radio,
  makeStyles,
  RadioGroup,
} from '@material-ui/core';
import {useFormContext} from 'react-hook-form';
import {ON_BOARDING_FIELDS} from '../utils/constants';
import {colors} from '../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  radioGroup: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  error: {
    color: colors.error,
    fontSize: '12px',
    marginTop: '.5rem',
  },
}));

type Option = {
  label: string,
  value: string,
};

const options: Option[] = [
  {
    label: 'Recién voy a empezar',
    value: 'TO_DEFINE',
  },
  {
    label: '1-10 ventas',
    value: 'LESS_THAN_10_WEEKLY_SALES',
  },
  {
    label: '11-30 ventas',
    value: 'LESS_THAN_30_WEEKLY_SALES',
  },
  {
    label: '31 a más',
    value: 'GREATER_THAN_30_WEEKLY_SALES',
  },
];

export default function WeeklySalesLevel() {
  const classes = useStyles();

  const {register, errors, setValue, clearErrors} = useFormContext();

  const [weeklySales, setWeeklySales] = useState('');

  useEffect(() => {
    register(ON_BOARDING_FIELDS.WEEKLY_SALES, {
      required: 'Este campo es requerido',
    });
  }, [register]);

  useEffect(() => {
    if (!weeklySales) return;

    setValue(ON_BOARDING_FIELDS.WEEKLY_SALES, weeklySales);
  }, [weeklySales, setValue]);

  const error = errors[ON_BOARDING_FIELDS.WEEKLY_SALES];

  useEffect(() => {
    //NOTE: this because the error is not cleared when the user selects a value
    if (!error) return;
    if (!weeklySales) return;
    clearErrors(ON_BOARDING_FIELDS.WEEKLY_SALES);
  }, [error, clearErrors, weeklySales]);

  return (
    <div>
      <RadioGroup className={classes.radioGroup} error={error}>
        {options.map(option => (
          <FormControlLabel
            key={option.value}
            onClick={() => setWeeklySales(option.value)}
            checked={weeklySales === option.value}
            control={<Radio color="primary" />}
            label={
              <Typography
                className={classes.nameEstado}
                color={!!error ? 'error' : 'inherit'}
              >
                {option.label}
              </Typography>
            }
            value={option.value}
          />
        ))}
      </RadioGroup>

      {error && (
        <div className={classes.error}>
          <span>{error.message}</span>
        </div>
      )}
    </div>
  );
}
